import { CountryCode } from 'interfaces/Country'
import { Attributes } from 'lib/hooks/useWebConfig/useWebConfigAttributes'
import { WebsiteConfigFlagParams } from './webConfigFlags'
import { getWebConfigStoredVariants, storeWebConfigStoredVariants, validateStoredVariants } from './storage'

export type WebsiteConfigExperimentVariant = {
    identifier: string
    config: {
        [x in WebsiteConfigFlagParams]?: boolean
    }
}

export interface WebsiteConfigExperiment {
    variants: WebsiteConfigExperimentVariant[]
    isActive: (attributes: Attributes) => boolean
}

export const webConfigExperiments = [
    {
        variants: [
            {
                identifier: 'seo_know_page_twitter_download_card_variant_0',
                config: {
                    showExperiment1: true,
                },
            },
            {
                identifier: 'seo_know_page_twitter_download_card_variant_1',
                config: {
                    showExperiment1: false,
                },
            },
        ],
        isActive: (attributes: Attributes) => {
            return attributes.countryCode === CountryCode.Germany
        },
    },
    {
        variants: [
            {
                identifier: 'seo_know_page_twitter_download_variant_0',
                config: {
                    showWebAppEntrypoint: true,
                },
            },
            {
                identifier: 'seo_know_page_twitter_download_variant_1',
                config: {
                    showWebAppEntrypoint: false,
                },
            },
        ],
        isActive: (attributes: Attributes) => {
            return attributes.countryCode === CountryCode.Germany
        },
    },
    {
        variants: [
            {
                identifier: 'exp_variant_0',
                config: {
                    showEXP2: true,
                },
            },
            {
                identifier: 'exp_variant_1',
                config: {
                    showEXP2: false,
                },
            },
        ],
        isActive: (attributes: Attributes) => {
            return attributes.countryCode === CountryCode.UnitedStates
        },
    },
]

const getIdentifiers = (experiments: WebsiteConfigExperiment[]) =>
    experiments
        .map((exp) => exp.variants)
        .map((variants) => variants.map((v) => v.identifier))
        .flatMap((identifiers) => identifiers)

export function getWebConfigActiveExperimentsVariants(attributes: Attributes) {
    const storedVariants = getWebConfigStoredVariants()

    const possibleIdentifiers = getIdentifiers(webConfigExperiments.filter((experiment) => experiment.isActive(attributes)))

    if (validateStoredVariants(possibleIdentifiers, storedVariants)) return storedVariants!.variants

    const rolledIdentifiers: string[] = []

    const newVariants = webConfigExperiments
        .filter((experiment) => experiment.isActive(attributes))
        .map((experiment) => {
            const randomVariant = getRandomVariantConfig(experiment.variants)
            rolledIdentifiers.push(randomVariant.identifier)
            return randomVariant.config
        })

    storeWebConfigStoredVariants({
        identifiers: rolledIdentifiers,
        variants: newVariants,
    })

    return newVariants
}

function getRandomVariantConfig(variants: WebsiteConfigExperimentVariant[]): WebsiteConfigExperimentVariant {
    return variants[Math.floor(Math.random() * variants.length)]
}

export const getVariantKeyAndValue = (variantConfig: WebsiteConfigExperimentVariant['config']) => {
    const variantValue = Object.entries(variantConfig)[0]
    return {
        identifier: variantValue[0],
        value: variantValue[1],
    }
}
